import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { AssetStateTypeComponent } from './components/asset-state-type.component';
import { AssetStateTypeRoutingModule } from './asset-state-type-routing.module';

@NgModule({
  declarations: [AssetStateTypeComponent],
  imports: [
    AssetStateTypeRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
  ],
})
export class AssetStateTypeModule {}

export function loadAssetStateTypeModuleAsChild() {
  return Promise.resolve(AssetStateTypeModule);
}
